
import React from 'react';
import i18n from '../../i18n';
import _ from 'lodash';
import { Menu, MenuExitInfo } from '../../constants/type.constant';
import CheckIcon from '@material-ui/icons/Check';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from '../../messenger/module';
import { DefaultRequest } from '../../requests/default.request';
import { getCacheField } from '../../tools/get-cache-field';
import MoodIcon from '@material-ui/icons/Mood';
import { StateManager } from '../../redux/stateManager';
/**
 * 开台页面--菜单卡片组件
 */
class MenuItem extends React.Component<Props, State>{

    public messengerModule: MessengerModule;
    // 货币符号
    public currency_name: string = '€';
    constructor(props: Props) {
        super(props);
        this.state = {
            // isLoadImg: true,
            extraChild: [],
            extraNormal: [],
            extraOther: [],
        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
        this.currency_name = StateManager.getFromCache('currency_name') || '€';

    }
    // 显示item_name1或item_name2
    public isShowName1 = true;

    public async componentDidMount() {
        const { item } = this.props;
        let extra_child = item?.extra_child?.split(',');
        let extra_normal = item?.extra_normal?.split(',');
        let extra_other = item?.extra_other?.split(',');
        let menuArray = _.compact(_.union(extra_child, extra_normal, extra_other));
        if (menuArray && menuArray.length > 0) {
            let menuInfo = await DefaultRequest.getMenuExitInfo(menuArray.join());
            if (menuInfo) {
                this.setState({
                    extraChild: item.extra_child ? menuInfo.filter((item) => { return extra_child?.includes(String(item.item_id)) }) : [],
                    extraNormal: item.extra_normal ? menuInfo.filter((item) => { return extra_normal?.includes(String(item.item_id)) }) : [],
                    extraOther: item.extra_other ? menuInfo.filter((item) => { return extra_other?.includes(String(item.item_id)) }) : [],
                })
            }
        }
        const findRes = this.getSettingInfoValue('show-item-name1-or-item-name2')
        if (findRes) this.isShowName1 = findRes.value.showItemName1

    }


    public getSettingInfoValue(str: string) {
        const SETTING = getCacheField('settingInfo');
        return _.find(SETTING, ['name', str]);
    }

    render() {
        const { extraChild, extraNormal, extraOther } = this.state;
        const { item, updateState, selectedMenuId, disabled } = this.props;
        const IS_SELECT = (selectedMenuId === item.main_group_id) && !disabled;
        return (
            <div>
                <div
                    className="item-card"
                    style={{
                        background: `url(${_.get(item, 'url')}) no-repeat`,
                        backgroundSize: 'cover'
                    }}
                    onClick={() => {
                        updateState({ selectedMenuId: item.main_group_id })
                    }}
                >
                    {/* 暗色透明遮罩 */}
                    <div style={IS_SELECT ?
                        {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            backgroundColor: '#2d334f',
                            width: '100%',
                            height: '100%',
                            borderRadius: 10,
                            opacity: .92,
                            border: ' 3px solid #00CCCC'
                        } : {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            backgroundColor: '#474D6E',
                            width: '100%',
                            height: '100%',
                            borderRadius: 10,
                            opacity: .92,
                            boxShadow: '0px 10px 25px rgb(0 0 0 / 41%)'
                        }}>
                    </div>

                    <div className={`item-name ${disabled ? 'home' : ''}`}>
                        {item.main_group_name}
                    </div>
                    <div className='item-content'>
                        <div className="person-box">
                            {/* 大人 */}
                            <div className="dultFee">
                                <div className="basisfee-img-adults basisfee-img" />
                                <div className="basisFeestyle">
                                    <div style={{ color: '#fff' }}>{i18n.t('auto_open_page_adults')}</div>
                                    <div style={{ color: '#00CCCC', fontWeight: 'bold' }}>
                                        {
                                            !!item?.normal_price &&
                                            `${this.currency_name} ${_.get(item, 'normal_price', 0).toFixed(2)}`
                                        }
                                    </div>
                                </div>
                            </div>

                            {/* 成人--额外价格 */}
                            <div className='extraBox'>
                                {
                                    extraNormal.map((item, index) => {
                                        return (
                                            <li key={index} className="extFeeList">
                                                <p className='extName'>{this.isShowName1 ? item.item_name1 : item.item_name2}</p>
                                                <p className='extraPrice'>
                                                    {
                                                        !!item?.price_1 &&
                                                        `${this.currency_name} ${_.get(item, 'price_1', 0).toFixed(2)}`
                                                    }
                                                </p>
                                            </li>
                                        );
                                    })
                                }
                            </div>
                            {/* 分割线-- 兼容Android写法 */}
                            <div style={{
                                borderWidth: 0.8,
                                borderStyle: 'dashed',
                                borderColor: '#767C9D',
                                borderRadius: 0.1,
                                marginTop: 15,
                                marginBottom: 25
                            }} />
                            {/* 小孩 */}
                            <div className="childFee">
                                <div className="basisfee-img-children basisfee-img" />
                                <div className="basisFeestyle">
                                    <div style={{ color: '#fff' }}>{i18n.t('auto_open_page_children')}</div>
                                    <div style={{ color: '#00CCCC', fontWeight: 'bold' }}>
                                        {
                                            !!item?.child_price &&
                                            `${this.currency_name} ${_.get(item, 'child_price', 0).toFixed(2)}`
                                        }
                                    </div>
                                </div>
                            </div>

                            {/* 小孩--额外价格 */}
                            <div className='extraBox'>
                                {
                                    extraChild.map((item, index) => {
                                        return (
                                            <li key={index} className="extFeeList">
                                                <p className='extName'>{this.isShowName1 ? item.item_name1 : item.item_name2}</p>
                                                <div className='extraPrice'>
                                                    {
                                                        !!item?.price_1 &&
                                                        `${this.currency_name} ${_.get(item, 'price_1', 0).toFixed(2)}`
                                                    }
                                                </div>
                                            </li>
                                        );
                                    })
                                }
                            </div>

                            {/* 其他 */}
                            {
                                !!item.other_price &&
                                <>
                                    {/* 分割线-- 兼容Android写法 */}
                                    <div style={{
                                        borderWidth: 0.8,
                                        borderStyle: 'dashed',
                                        borderColor: '#767C9D',
                                        borderRadius: 0.1,
                                        marginTop: 15,
                                        marginBottom: 25
                                    }} />
                                    {/* 其他 */}
                                    <div className="childFee">
                                        <MoodIcon className="basisfee-img-other basisfee-img" />
                                        <div className="basisFeestyle">
                                            <div style={{ color: '#fff' }}>{i18n.t('auto_open_page_other')}</div>
                                            <div style={{ color: '#00CCCC', fontWeight: 'bold' }}>
                                                {
                                                    `${this.currency_name} ${Number(_.get(item, 'other_price', 0)).toFixed(2)}`
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    {/* 其他--额外价格 */}
                                    <div className='extraBox'>
                                        {
                                            extraOther.map((item, index) => {
                                                return (
                                                    <li key={index} className="extFeeList">
                                                        <p className='extName'>{this.isShowName1 ? item.item_name1 : item.item_name2}</p>
                                                        <div className='extraPrice'>
                                                            {
                                                                !!item?.price_1 &&
                                                                `${this.currency_name} ${_.get(item, 'price_1', 0).toFixed(2)}`
                                                            }
                                                        </div>
                                                    </li>
                                                );
                                            })
                                        }
                                    </div>
                                </>

                            }

                        </div>

                        {/*  */}
                        {
                            !disabled &&
                            <div className="item-selected" style={IS_SELECT ? { backgroundColor: '#197A84' } : {}}>
                                <div style={{ fontSize: 16 }}>{i18n.t('auto_open_page_select')}</div>
                                {
                                    IS_SELECT &&
                                    <div className="check-icon">
                                        <CheckIcon style={{ fontSize: '1.3rem' }} />
                                    </div>
                                }
                            </div>
                        }
                    </div>

                </div>
            </div>
        )
    }
}
export default withSnackbar(MenuItem);

// **********
// TYPE
// **********

type Props = {
    item: Menu;
    selectedMenuId?: number;
    updateState: (val: any) => void;
    // 是否可点击 首页使用
    disabled?: boolean;

} & WithSnackbarProps

type State = {
    extraChild: Array<MenuExitInfo>;
    extraNormal: Array<MenuExitInfo>;
    extraOther: Array<MenuExitInfo>;
}